import {
  faTwitter,
  faLinkedin,
  faGithub,
} from '@fortawesome/free-brands-svg-icons'

export const SOCIAL_MEDIA_ACCOUNTS = [
  {
    name: 'LinkedIn',
    icon: faLinkedin,
    url: 'https://www.linkedin.com/in/leerichardson2/',
  },
  {
    name: 'Twitter',
    icon: faTwitter,
    url: 'https://twitter.com/leerichftw',
  },
  {
    name: 'Github',
    icon: faGithub,
    url: 'https://github.com/seaoflee',
  },
]
